import React from 'react';
import {
  ALL_ASSETS_WITH_SITES_AG,
  ALL_ASSETS_WITH_SITES_AR,
  ALL_ASSETS_WITH_SITES_BR,
  ALL_ASSETS_WITH_SITES_CG,
  ALL_ASSETS_WITH_SITES_DK,
  ALL_ASSETS_WITH_SITES_IQ,
  ALL_ASSETS_WITH_SITES_NG,
  ALL_ASSETS_WITH_SITES_UK,
  AssetsAg,
  AssetsAr,
  AssetsBr,
  AssetsCg,
  AssetsDk,
  AssetsIq,
  AssetsNg,
  AssetsUk,
  CountryData,
} from 'types/wellGuardian';

export const getSiteList = (
  countryState: string,
  assetFilter: string,
  siteValue: (value: string) => React.ReactNode,
) => {
  if (countryState === CountryData.denmark) {
    return ALL_ASSETS_WITH_SITES_DK[assetFilter as AssetsDk]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.nigeria) {
    return ALL_ASSETS_WITH_SITES_NG[assetFilter as AssetsNg]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.angola) {
    return ALL_ASSETS_WITH_SITES_AG[assetFilter as AssetsAg]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.congo) {
    return ALL_ASSETS_WITH_SITES_CG[assetFilter as AssetsCg]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.brazil) {
    return ALL_ASSETS_WITH_SITES_BR[assetFilter as AssetsBr]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.iraq) {
    return ALL_ASSETS_WITH_SITES_IQ[assetFilter as AssetsIq]?.sites?.map(site => siteValue(site));
  } else if (countryState === CountryData.argentina) {
    return ALL_ASSETS_WITH_SITES_AR[assetFilter as AssetsAr]?.sites?.map(site => siteValue(site));
  } else {
    return ALL_ASSETS_WITH_SITES_UK[assetFilter as AssetsUk]?.sites?.map(site => siteValue(site));
  }
};
